'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_NAMESPACE = exports.DEFAULT_NAMESPACE = '/';
var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';


//////////////////
// WEBPACK FOOTER
// ./~/coact/~/redux-actions/lib/constants.js
// module id = 1116
// module chunks = 0